/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class AuthorizationConstants {
}
AuthorizationConstants.GLOBAL_KEY = 'window.sirius.shared.authorization';
AuthorizationConstants.DEFAULT_NAMESPACE = 'platform';
AuthorizationConstants.DEFAULT_NAMESPACE_SEPARATOR = '::';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aG9yaXphdGlvbi5jb25zdGFudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL2F1dGhvcml6YXRpb24vYXV0aG9yaXphdGlvbi5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sc0JBQXNCOztBQUNSLGlDQUFVLEdBQUcsb0NBQW9DLENBQUM7QUFFbEQsd0NBQWlCLEdBQUcsVUFBVSxDQUFDO0FBQy9CLGtEQUEyQixHQUFHLElBQUksQ0FBQyJ9